<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive code="exp_ouinon" :live="liveSasArmCanada(9129)" v-model="sasArmCanada.experiencesDeTravail" />
    <data-iterator
      :list="sas.sasExperienceProfessionnelles"
      add-new-text="Ajouter une experience de travail"
      :live="{ endpoint: 'sas-experiences-professionnelles', sasId: sas.id }"
      :icon="$getIcon('expPro')"
      :valids="valids"
      ref="dataIterator"
      :opqIf="estOui(sas.sasArmCanada.experiencesDeTravail)"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">{{ item.titreDuPosteOccupe }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="exp_titre" v-model="item.titreDuPosteOccupe" :live="liveSasExperiencePro(6603, item)" />
        <MemoLive code="exp_description" v-model="item.descriptionDesResponsabilites" :live="liveSasExperiencePro(6604, item)" />
        <DatePickerLive code="exp_debut" v-model="item.dateDeDebut" :live="liveSasExperiencePro(6605, item)" />
        <DatePickerLive code="exp_fin" v-model="item.dateDeFin" :live="liveSasExperiencePro(6606, item)" />
        <FileInput code="exp_preuve" :file="item.preuve" :live="liveSasExperiencePro(6609, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasArmCanada() {
      return this.sas.sasArmCanada
    }
  },
  methods: {
    liveSasExperiencePro(cle, item) {
      return { endpoint: "sas-experiences-professionnelles", cle: cle, fileId: item.id }
    },
    liveSasArmCanada(cle) {
      return { endpoint: "sas-reconnaissance-arm-canada", cle: cle, fileId: this.sasArmCanada.id }
    }
  }
}
</script>

<style>
</style>